module.exports = __webpack_public_path__ + "img/mind_skeleton_7.6dcd8cad.png";